/**
 * 页面回退拦截页面
 * @param { string } backUrl 同域下的域名地址
 *
 */

let isPageLoad = false;

if (typeof window === 'object') {
    window.addEventListener('load', () => {
        isPageLoad = true;
    });
}

const pagePopstateHandle = (backUrl) => {
    if (
        typeof window !== 'object' ||
        !backUrl ||
        document.referrer.includes('ifeng.com') ||
        window.top !== window.self ||
        !backUrl.includes(location.host)
    ) {
        return false;
    }

    const startTime = new Date().getTime();
    const pageUrl = location.href;

    window.addEventListener(
        'popstate',
        () => {
            const endTime = new Date().getTime();

            if (endTime - startTime > 200 && location.href.includes(backUrl)) {
                location.reload();
            }
        },
        false,
    );

    try {
        window.history.replaceState(null, '', backUrl);
        window.history.pushState('', '', pageUrl);
    } catch (e) {
        console.error(e);
    }
};

const addBackGuide = (backUrl) => {
    if (
        typeof window !== 'object' ||
        !backUrl ||
        document.referrer.includes('ifeng.com') ||
        window.top !== window.self
    ) {
        return false;
    }

    if (isPageLoad) {
        pagePopstateHandle(backUrl);
    } else {
        window.addEventListener(
            'load',
            () => {
                pagePopstateHandle(backUrl);
            },
            false,
        );
    }
};

export { addBackGuide };
